import { useCallback, useMemo } from 'react';
import { useVisibility } from '../../../hooks/useVisibility';
import { PROMOTED_GIGS, VIDEO_STRIP_EXPERIMENT } from '../../../GigCards/Components/constants';
import { onVideoStripPositionVisible } from './videoStripUtils';

export const useVideoStripVisibility = ({ renderGigProps, renderableGigs, gigs }) => {
    const clientExperimentsGroups = renderGigProps?.clientExperimentsGroups;
    const experimentGroup = Number(clientExperimentsGroups?.[VIDEO_STRIP_EXPERIMENT]);

    const onVisible = useCallback(() => {
        if (clientExperimentsGroups) {
            onVideoStripPositionVisible(clientExperimentsGroups);
        }
    }, [clientExperimentsGroups]);

    const videoStripRef = useVisibility(onVisible);
    const promotedGigRef = useVisibility(onVisible);

    const videoStripPosIndex = useMemo(() => {
        if (experimentGroup !== 1 || !Array.isArray(renderableGigs)) return -1;

        return renderableGigs.findIndex(
            (gig, i) => i > 0 && gig.type === PROMOTED_GIGS && gigs?.[i - 1]?.type !== PROMOTED_GIGS
        );
    }, [experimentGroup, renderableGigs, gigs]);

    return {
        videoStripRef,
        promotedGigRef,
        videoStripPosIndex,
    };
};
